export default __webpack_public_path__ + "static/banner-moc-1-2-7cd22b1acc1edb7f52fac7ad89edb567.png";